import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Common } from '../../components';
//import PhoneDone from '../../assets/images/cat_complete.svg';
import PhoneDone from '../../assets/images/thank-you-cat.png';
import IDCardFailed from '../../assets/images/id-card-failed.svg';
import CompleteFooter from '../../assets/images/complete-footer.svg';

import { actionTracking, actionTracking2 } from '../../store/common/actions';
import { clearApplicationDraft } from '../../utils/applicationDraft';

function ConfirmApplicationComplete() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [countDown, setCountDown] = useState(15);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (!location?.state?.tracking_2nd) {
            dispatch(actionTracking(window.location.href));
        } else {
            dispatch(actionTracking2({
                url: window.location.href
            }));
        }
        clearApplicationDraft();
        let count = 15;
        const time = setInterval(() => {
            count -= 1;
            setCountDown(count);
            if (count <= 0) {
                clearInterval(time);
                goToRoot('/');
            }
        }, 1000);
    }, [dispatch]);

    // useEffect(() => {
    //   if (!location.state?.status) {
    //     navigate('/');
    //   }
    // }, [location.state?.status, navigate]);

    useEffect(() => {
        const disableBack = () => {
            navigate(1);
        };
        window.addEventListener('popstate', disableBack);
        return () => {
            window.removeEventListener('popstate', disableBack);
        };
    }, [navigate]);

    const goToRoot = (url) => {
        navigate(url, { state: { status: false } });
        clearApplicationDraft();
        localStorage.removeItem('access_token');
        localStorage.removeItem('application_phone');
    };

    console.info(location.state?.content);

    return (
        <div className="bg-white p-5">
            <Common.StepBar active={4} />
            <p className="flex-1 text-2xl text-primary2 text-right font-semibold border-b border-gray2 mb-4 pb-4">申請完成</p>
            <div className="flex justify-center">
                <img className="w-1/2 lg:w-auto" src={location?.state?.card_failed ? IDCardFailed : PhoneDone} alt="" />
            </div>
            <p className="text-2xl text-primary mb-4 text-center">貸款申請成功</p>
            {/* <div className="bg-[#fff9f4] p-3 rounded-xl">
                <p className="text-gray text-center text-xl">以下是閣下的申請編號</p>
                <p className="text-gray1 text-center mt-3">申請編號亦會透過手機短訊(SMS)發送到閣下所登記之電話號碼，方便日後查閱申請進度。（接收SMS可能需時數分鐘，請耐心等候。）</p>
                <div className="py-3 bg-primary2 text-white text-center text-xl mt-4">
                    <p>{location.state?.content?.request_id}</p>
                </div>
                <p className="text-gray1 mt-4">感謝閣下的申請，我們的貸款專員會於營業時間內盡快致電給閣下核對資料。請留意「2366 8859」或「3911」開頭的電話號碼。如有任何疑問，歡迎於辦公時間內致電 2366 8859。</p>
                <p className="text-primary mt-4">為了順利聯絡閣下，請把以上電話號碼從攔截電話應用程式 (如: 小熊來電) 中移除，謝謝。</p>
            </div> */}
            {/* <div className="flex justify-center items-center w-full my-7">
                <div className="ml-[-95px]">
                    <img src={CompleteFooter} alt='' />
                </div>
                <div>
                    <p className="text-primary text-2xl">立即上載文件 <br />
                        加快審批進度！</p>
                </div>
            </div> */}
            {/*
                //이관후 신청 프로세스 변경으로 인한 주석 : 20260205
                location.state?.completed ?
                    <>
                        <p className="text-gray">申請編號亦會透過手機短訊(SMS)發送到閣下所登記之電話號碼，方便日後查閱申請進度。(接收SMS可能需時數分鐘，請耐心等候。)</p>
                        <p className="text-gray mt-4">感謝閣下的申請，我們會盡快處理閣下的申請及與閣下聯絡。如有任何疑問，歡迎於辦公時間內致電 2366 8859。</p>
                    </>
                    : (
                        location.state?.no_form23 ? 
                            <p className='text-gray'>貸款申請已完成。我們的貸款專員會於辦公時間內盡快聯絡閣下跟進貸款申請，請留意2366 8859的來電。</p>
                            : 
                            <p className="text-gray"> 貸款申請已完成。由於未能完成本人認證, 我們的貸款專員會於辦公時間內盡快聯絡閣下跟進貸款申請, 請留意2366 8859的來電。</p>
                    )
            */}
            <p className='text-gray'>貸款申請已完成。我們的貸款專員會於辦公時間內盡快聯絡閣下跟進貸款申請，請留意2366 8859的來電。</p>
            <div className="flex justify-center mt-9 mb-4">
                <button className="rounded-full text-white text-xl bg-primary px-14 py-3" onClick={() => goToRoot('/')}>
                    返回主頁​ <span>( {countDown} )</span>
                </button>
            </div>
            {/* <div className="flex justify-center mt-9 mb-4">
                <button onClick={() => goToRoot('/?open=check_status')} className="rounded-full text-white text-xl bg-primary px-14 py-3">
                    上載文件
                </button>
            </div>
            <div className="flex justify-center mb-4">
                <button onClick={() => goToRoot('/')} className="rounded-full text-white text-xl bg-alto px-14 py-3">
                    返回主頁
                </button>
            </div> */}
        </div>
    );
}

export default ConfirmApplicationComplete;
